import { CreatePasswordForm } from "@modules";
export const PageChangePassword = () => {
  return <CreatePasswordForm />;
};
